import { Button, Text, Divider } from "@mantine/core";
import { cedisLocale } from "../../helpers/utilities";

/**
 * RedeemedBenefitsDisplay component (UI: utilize / value)
 *
 * Props:
 * - redeemedBenefits: array - array of utilized value
 * - onDeleteBenefit: function(index) - callback when a value entry is deleted
 * - onClearAll: function - callback when all are cleared
 */
export const RedeemedBenefitsDisplay = ({
  redeemedBenefits,
  onDeleteBenefit,
  onClearAll,
}) => {
  if (!redeemedBenefits || redeemedBenefits.length === 0) {
    return null;
  }

  const totalRedeemedAmount = redeemedBenefits.reduce(
    (sum, benefit) => sum + benefit.amount,
    0
  );

  return (
    <div className="mb-2 border rounded-3 p-2">
      <strong className="text-success">Care Value Utilized</strong>
      {redeemedBenefits.map((benefit, index) => (
        <div
          key={index}
          className="d-flex justify-content-between align-items-center my-2">
          <div className="d-flex align-items-center gap-2">
            <Text size="sm">{benefit.careCategory?.name || "Cashless"}</Text>
            <Button
              size="xs"
              color="red"
              variant="subtle"
              onClick={() => onDeleteBenefit(index)}
              style={{ padding: "2px 6px", minWidth: "auto" }}>
              ×
            </Button>
          </div>
          <Text size="sm">{cedisLocale.format(benefit.amount)}</Text>
        </div>
      ))}
      <Divider className="my-0" />
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-2">
          <Text size="sm" weight={600}>
            Total Care Value Utilized
          </Text>
          <Button
            size="xs"
            color="red"
            variant="subtle"
            onClick={onClearAll}
            style={{ padding: "2px 6px", minWidth: "auto" }}>
            Clear All
          </Button>
        </div>
        <Text size="sm" color="teal" weight={800}>
          {cedisLocale.format(totalRedeemedAmount)}
        </Text>
      </div>
    </div>
  );
};
